/*
Generate a new collection
@class Collection
@constructor
@namespace collections.collection
@param {String} the type of the handler "screen" / "external" / nothing more yet...
@param {JQuery} the div to register the message queue
@return {Object} an instance of the collection object; (holding the needed handler object) */
function CollectionFavorites () {
    this.source = "CollectionFavorites";
}

CollectionFavorites.prototype = new window.vcTemplate();

CollectionFavorites.prototype.init = function () {
    ///<summary>
    /// Initializes the Collection Favorites <br/>
    /// gets the div with the container and the global variables <br/>
    /// reacts on external messages
    ///</summary>
    var me = this;
    try {
    
        me.globalsDIV = $("#divCollectionContainer");
        window._VCMQ.addConsumer('COLLMQ');
        window._VCMQ.consume($("#divCollectionContainer"), 'COLLMQ', function (event) { me.events(event); });
        window.addEventListener("message", function (e) {
           // console.info()


            //if (typeof e.data.msg !== "string" ||  e.origin !== window.location.protocol.concat("//" + window.location.host)) {
            //    me.writeError(me.source + ".getMessageFromParentWindow()", "WRONG INPUT: " + e.data.msg);
            //} else {
                if(e.data.msg === "HANDLER_INIT") {me.handler.runningPreview = true;}
                window._VCMQ.produce(me.globalsDIV, "COLLMQ", e.data.msg, e.data.val);
          //  }
      
        }, true);
        $("#divCollectionContainer").height(window._iBrowserHeight);
        //The current timestamp Format: 'dd.mm.yyyy h:m:s'
        me.now = window.getCurrentTimestamp();
        //Navigation === 1..ON / 0..OFF
        //Die Navigation muss nochmal extra irgendwo konfiguriert werden...
        me.nav = 1;
        //DebugInfos === 0..OFF / 1..Resoulution / 2..Not implemented yet
        me.bug = 0;
        //The datatable storing the current collection-playlist
        me.playlist = -1;
        //The datatable storing the current collection-sub-playlist
        me.sublist = -1;
        //The current index of the collection
        me.index = -1;
        //The current index of the sub collection
        me.index_sub = -1;
        //The timer representing the currently showing collection entry
        me.timer = -1;
        me.timerSub = -1;
        me.timerError = -1;
        //Counter indicating the next refresh === -1..Disabled / 5..Default 
        me.refreshURL = 5;
        if (me.checkHTMLIds() === true) {
            //Previously this was the Playlist ID
            me.collID = parseInt($("#globalCollID").html(), 10);
            me.subCollID = parseInt($("#globalSubID").html(), 10);
            //Project ID 
            me.pid = parseInt($("#globalPid").html(), 10);

            //Logger ID
            me.blid = parseInt($("#globalBlid").html(), 10);

            // DeviceType 'NET', 'APP', 'TV'
            me.deviceID = parseInt($("#globalDevice").html(), 10);

            //The ID of the Collection or the Playlist. Depends on the Device and the CollectionType.
            me.id = parseInt($("#globalID").html(), 10);
        } else {
            me.refreshUrl = -1;
            me.writeError("CollectionFavorites.init", "AN ID is mising");
            me.location.href = "bluaul.error/500.aspx";
        }

        me.cm = "#content_main";
        me.cms = me.cm.replace("#", "");

        me.cs = "#content_sub";
        me.css = me.cs.replace("#", "");

        me.iBASE_WIDTH = 1920;
        me.iBASE_HEIGHT = 1080;
        me.dHEIGHT_FACTOR = window._iBrowserHeight / me.iBASE_HEIGHT;
        me.dWIDTH_FACTOR = window._iBrowserWidth / me.iBASE_WIDTH;

        me.reloadAfter15Min = false;
        me.handlerType = "screen";
        me.vcVisual = new window.vcVisual();

        //Dies wird aus sicherheitsgründen hier gesetzt so dass spätestens nach dem 5. mal refreshed wird...
        me.refreshURL = 0;

        me.handler = new window.ScreenHandlerFavorites();
        me.handler.init(me.globalsDIV, parseInt($("#globalTheme").html(), 10), parseInt($("#globalMaster").html(), 10), me.nav);
        //    default:
        //        //The standard handler object to generate master and theme and all other needed methods
        //        this.handler = null;
        //}

    } catch (ex) {
        me.writeError("CollectionFavorites.init", ex);
    }
};
CollectionFavorites.prototype.checkVariableIdsForWSCall = function() {
    var me = this;
    var bRet = false;
    try {
    
        if ($.isNumeric(me.collID) === false ||
            $.isNumeric(me.subCollID) === false ||
            $.isNumeric(me.pid) === false ||
            $.isNumeric(me.blid) === false ||
            $.isNumeric(me.id) === false) 
        {
            bRet = false;
            me.writeError("CollectionFavorites.checkVariableIdsForWSCall ", 
                "An Id does not convert to numeric: collid:" + me.collId  + " subid: " +  me.subCollID + " pid: " + me.pid + " blid: " +  me.blid  & " id:" + me.id);
        } else {
            bRet = true;
        }
    } catch (ex) {
        me.writeError("CollectionFavorites.checkHtmlIds", ex);
    }
    return bRet;
};

CollectionFavorites.prototype.checkHTMLIds = function() {
    var me = this;
    var bRet = false;
    try {


        if ($.isNumeric($("#globalCollID").html()) === false ||
            $.isNumeric($("#globalSubID").html()) === false ||
            $.isNumeric($("#globalPid").html()) === false ||
            $.isNumeric($("#globalBlid").html()) === false ||
            $.isNumeric($("#globalID").html()) === false ||
            $.isNumeric($("#globalDevice").html()) === false) {
            bRet = false;
  
            me.writeError("CollectionFavorites.checkHtmlIds ", 
                "An Id does not convert to numeric: collid:" + $("#globalCollID").html()  + " subid: " +  $("#globalSubID").html() + " pid: " + $("#globalPid").html() + " blid: " +  $("#globalBlid").html() + " Playlistid: " + $("#globalID").html() + " DeviceId: " + $("#globalDevice").html());
        } else {
            bRet = true;
        }
    } catch (ex) {
        me.writeError("CollectionFavorites.checkHtmlIds", ex);
    }
    return bRet;
};
CollectionFavorites.prototype.addContentDiv = function() {
    /// <summary>
    /// This function adds the basic divs to the body
    /// </summary>
    var me = this,
        s = "";
    try {
        if ($(me.cm).length === 0) {
            s += "<div id='" + me.cms + "' class='round'><div class='collEle'>" + me.handler.resources.collDivContentMain_lbl + "</div></div>";
            s += "<div id='" + me.css + "' class='round'><div class='collEle'>" + me.handler.resources.collDivContentSub_lbl + "</div></div>";
            me.globalsDIV.append(s);
        }
    } catch (ex) {
        me.writeError(me.source + "addContentDiv", ex);
    }
};

CollectionFavorites.prototype.setEntry = function() {
    /// <summary>
    /// This function adds the basic divs to the body
    /// </summary>
    var me = this,
        ms = 0;
    try {
        //Set Entry-specific navigation!
        window._VCMQ.produce(me.globalsDIV, "COLLMQ", "HANDLER_SETENTRY_NAVIGATION", me);

        //Set Entry-specific Master!
        window._VCMQ.produce(me.globalsDIV, "COLLMQ", "HANDLER_SETENTRY_MASTER", me);

        //Set the entry!
        $(".content:visible").fadeOut(ms, "linear").find("video.vid").each(function (idx, element) { element.pause(); });
        $(me.cm + "_" + me.index).fadeIn(ms, "linear").find(".SubSignals").trigger("subSignalVisible");
        $(me.cm +"_" +me.index).find("video.vid").each(function(idx, element) {element.currentTime = 0; element.play();});
        //$(".content:visible");

    } catch (ex) {
        me.writeError(me.source + ".setEntry", ex);
    }
};

/*  */
CollectionFavorites.prototype.flushPlaylist = function() {
    var me = this;
    try {
        if (me.playlist === null) {
            return false;
        }
        for (var i = 0; i < me.playlist.length; i++) {
            var fn = window["gc" + i + ""];
            if (typeof fn === 'function') {
                fn();
            }
        }
        return true;
    } catch (ex) {
        me.writeError("CollectionFavorites.flushPlaylist", ex);
        return false;
    }

};


/*  */
CollectionFavorites.prototype.loadPlaylist = function() {
    var me = this,
        pll = 0,
        s,
        w,
        h,
        type;
    try {
        if (parseInt($(me.cm).width(),10) >= 620) {
            type = 2;
        } else {
            type = 1;
        }
        $(me.cm).html("");
        for (var i = 0; i < me.playlist.length; i++) {
            pll += me.playlist[i].duration;
            //generate the divs
            w = parseInt($(me.cm).width(), 10);
            h = parseInt($(me.cm).height(), 10);
            s = "<div id='" + me.cms + "_" + i + "' ";
            s += "class='content round' style='width:100%; height:100%;'>";
            s += "</div>";
            $(me.cm).append(s);
            me.preloadEntry(me.cms + "_", i, me.playlist[i].visualname, me.playlist[i].parameter, me.playlist[i].signalparameter, w, h, type, me.handler.preloadPadding);
        }

        if (me.reloadAfter15Min) {
            //edit refresh counter to match the 15min reload time
            me.refreshURL = Math.floor(15 * 60 / pll / 2);
        }
        window._VCMQ.produce(me.globalsDIV, "COLLMQ", "HANDLER_SETNAVIGATION");
        window._VCMQ.produce(me.globalsDIV, 'COLLMQ', 'CHANGEENTRY');
    } catch (ex) {
       me.writeError("CollectionFavorites.loadPlaylist", ex);
    }
};

/*  */
CollectionFavorites.prototype.runPlaylist = function() {
    var me = this;
    //Run through the playlist only if there is something to run through
    //This stops the whole reload cycle so be carefull to use it on the player!! this is for external only...
    try {
        if (me.handlerType ===  "screen" || me.playlist.length > 1) {
            me.timer = setTimeout(function() {
                window._VCMQ.produce(me.globalsDIV, 'COLLMQ', 'CHANGEENTRY');
            }, me.playlist[me.index].duration * 1000);
        }
    } catch (ex) {
        me.writeError("collectionFavorites.runPlaylist", ex);
    }
};


CollectionFavorites.prototype.runSublist = function() {
    var me = this;
    try {
        if (me.sublist.length > 1) {
            me.timerSub = setTimeout(function() {
                window._VCMQ.produce(me.globalsDIV, 'COLLMQ', 'CHANGEENTRY_SUB');
            }, me.sublist[me.index_sub].duration * 1000);
        }
    } catch (ex) {
        me.writeError("collectionFavorites.runSubList", ex);
    }
};

/*
Checks two indices:
    1. The Playlist index;
        This indes is increased to show the next entry in the playlist.
        If the end is reached the index is set to -1 to beginn again!
    2. The Refreshcounter;
        If the end of the cached cycle is reached (_refrehURL === 0), the counter is reset to the initial value (3x).
        Then the internet connection is checked and if OK the page is refreshed (see executePing()).
        If no connection is available the cached playlist starts from the beginning. */
CollectionFavorites.prototype.changeEntry = function() {
    var me = this;
    try {
        if (me.playlist.length - 2 < me.index) {
            //End of Playlist! Set Index to beginning! (-1 because the index is increased by 1 at the end of the function!)
            me.index = -1;
            if (me.refreshURL === 0) {
                me.refreshURL++;
                //If it is time to refresh the Page, check the internet connection and act accordingly!
                //and Exit the function set to index -1 beacause ping calls either a reload 
                //(in this case it doesent matter) or a changeentry 
                //(then it is key that the index is set to -1 because at the end of the function 
                //the index is increased by one. This is because the timer (see runPlaylist) 
                //is set after the entry is changed. This is for a uniform call of changeEntry and runPlaylist!)
                window._VCMQ.produce(me.globalsDIV, 'COLLMQ', 'PING');
                return false;
            } else {
                //Check if refresh url counter is disabled === -1 --> Do nothing if so!
                if (me.refreshURL > 0) { //If no refresh is in order... Business as usual!
                    me.refreshURL--;
                }
            }
        }

        me.index++;
        me.setEntry();
        me.runPlaylist();
        return true;
    } catch (ex) {
        me.writeError("CollectionFavorites.changeEntry", ex);
        return false;
    }
};

/*  */
CollectionFavorites.prototype.changeEntry_sub = function() {
    var me = this, ms = 0;
    try {
        if (me.sublist.length - 1 <= me.index_sub) {
            //End of Playlist! Set Index to beginning! (-1 because the index is increased by 1 at the end of the function!)
            me.index_sub = -1;
        }
        me.index_sub++;
        //Set the entry!
        $(".subcontent:visible").fadeOut(ms);
        $(me.cs + "_" + me.index_sub).fadeIn(ms);
        $(me.cs + "_" + me.index_sub).find(".SubSignals").trigger("subSignalVisible");

        me.runSublist();
    } catch (ex) {
        me.writeError("CollectionFavorites.changeEntry_sub", ex);
    }
};

/*
Appends a div with several debug informations based on the property _col.bug --> 0..OFF / 1..Resoulution / 2..Not implemented yet */
CollectionFavorites.prototype.setDebugInfos = function() {
    var me = this;
    try {
        if (me.bug > 0) {
            $("body").append("<div id='divDebugInfos' class='debug round frame' style='position:absolute; background-color:#800; color:#f9f8f3; display:none; font-family:Source Code Pro;'></div>");
            switch (me.bug) {
            case 1:
                var sTmp = "";
                sTmp += "Screen Res: " + screen.width + "x" + screen.height + "<br />";
                sTmp += "Avail. Res: " + screen.availWidth + "x" + screen.availHeight + "<br />";
                sTmp += "Window Res: " + $(window).width() + "x" + $(window).height() + " ";
                $("#divDebugInfos").html(sTmp).css("display", "block");
                break;
            case 2:
                break;
            }
        }
    } catch (ex) {
        me.writeError("CollectionFavorites.showDebugInfos", ex);
    }
};

/*
Loads the a single widget/chart as specified by the Parameters */
CollectionFavorites.prototype.preloadEntry = function(div, vcgid, vcvid, parameter, signalparameter, w, h, theme) {
    var me = this,
       height = h,
    width = w;
    try {
        if (isNaN(height)) {
            height = 0;
        }
             if (isNaN(width)) {
            width = 0;
        }
        me.vcVisual.addVisualBaseByName(div, vcvid, vcgid, me.now, height, width, parameter, signalparameter, theme);
    } catch (ex) {
        me.writeError("CollectionFavorites.preloadEntry", ex);
    }
};

/*
This takes the base URL (e.g.: https://smartenergy.eudt.at/html/collections/screen.aspx) cuts off all parameters including 'ref' and 'key' 
Afterwards the stored key will be added and the page is freshly called!
This is neccessary because ref=true needs to be cut off if the player lost the connection for more than 20 minutes. */
CollectionFavorites.prototype.reloadURL = function() {
    var me = this;
    try {
        var protocol = "https://";
        var sUrl = protocol + window.location.hostname + window.location.pathname + "?";
           //finally add the key and security version!
        sUrl += "key=" + me.visual.find("#globalKey").html();
        sUrl += "&v=" + me.visual.find("#globalVersion").html();
        sUrl += "&ref=1";

        window.location.replace(sUrl);

    } catch (ex) {
        me.writeError(me.source + ".reloadURL", ex);
    }
};

/*
If the ping fails call the next entry of the previously set _index (-1 set in changeEntry())
If successful the page is reloaded! */
CollectionFavorites.prototype.executePing = function() {

    var me = this;
    try {

        window.CollectionServiceFavorites.Ping(function() {
            //Success > RELOAD
            window._VCMQ.produce(me.globalsDIV, 'COLLMQ', 'RELOAD');
        }, function () {
            //Fail > CHANGEENTRY
            window._VCMQ.produce(me.globalsDIV, 'COLLMQ', 'CHANGEENTRY');
        });
    } catch (ex) {
        me.writeError(me.source + ".executePing", ex);
    }
};
/*
This function is just for better reading the code
It just gets the playlist and starts the internal collection loop */
CollectionFavorites.prototype.runCollection = function() {
    var me = this;
    try {
        me.getCollection();
    } catch (ex) {
        me.writeError(me.source + ".runCollection", ex);
    }
};


/*
This function loads the weather widget via webservice and adds the content directly to the specified div (see parameter).
@param {Widget} a Widget object filled with all variables. */
CollectionFavorites.prototype.setSingleWidget = function(w) {
    var me = this;
    try {
       var widgetHeight =parseInt(window.getComputedStyle($(w.div)[0])["height"],10);

        var widgetWidth = parseInt(window.getComputedStyle($(w.div)[0])["width"],10);
    
            if (window._iBrowserWidth === widgetWidth || widgetWidth === 0) {
                widgetWidth = parseInt(window._iBrowserWidth * 0.16, 10);
            }
            if (window._iBrowserHeight === widgetHeight || widgetHeight === 0 || widgetHeight < 70) {
                widgetHeight = parseInt(window._iBrowserHeight * 0.16, 10);
            }
                if (isNaN(widgetHeight)) {
            widgetHeight = 0;
        }
             if (isNaN(widgetWidth)) {
            widgetWidth = 0;
        }
        if (w.widgetName === "VISUAL_FILEVIEWER") {
            //if (w.div.css("display") !== "none") {
                me.vcVisual.addVisualBaseByName(w.container,w.widgetName,w.vcgid,me.now,widgetHeight,widgetWidth,w.widgetOptions,w.widgetOptions,2);
            //}
        } else {
            //if (w.div.css("display") !== "none") {
                
                  me.vcVisual.addVisualBaseByName(w.container,w.widgetName,w.vcgid,me.now,widgetHeight,widgetWidth,me.blid,w.widgetOptions,2);
                  me.visual.find("#divWind_" + w.vcgid).css({ "font-size": "1em" });
            //}
        }
    } catch (ex) {
        me.writeError(me.source + ".setSingleWidget", ex);
    }
};

/*
Downloads the validated Collection via the CollectionService
Stores the downloaded collection into the result variable (me.playlist)
Calls the loadPlaylist() function at the end to initialize the playlist run
@return {Boolean} true if the collection could be loaded, false otherwise */
CollectionFavorites.prototype.getCollection = function() {
    var me = this;
    try {
        if (me.checkVariableIdsForWSCall() === true) {
            window.CollectionServiceFavorites.getCollection(parseInt(me.pid,10), parseInt(me.blid,10),parseInt(me.collID,10),2,parseInt(me.id,10),function(result) {
                    if (result === null || result.length < 1) {
                        me.showInfo(me.resources.errGeneral, me.resources.errEmptyPlaylist, true);
                        return false;
                    } else {

                        me.index = -1;
                        me.playlist = null;
                        me.playlist = result;
                        me.loadPlaylist();
                        return true;
                    }
                },
                function(error) {
                    me.writeError(me.source + ".getCollection.WSCall", JSON.stringify(error));
                });
        } else {
              me.writeError(me.source + ".getCollection.checkVariables", "One or more of the variables is not integer");
        }
    } catch (ex) {
        me.writeError(me.source + ".getCollection");
    }
};

CollectionFavorites.prototype.getSubList = function () {
    ///<summary>
    /// Function to retrieve the Sublist from the Server <br/>
    /// calls the Webservice for get collection and starts the Sublist
    ///</summary>
    var me = this;
    try {
        if (me.checkVariableIdsForWSCall() === true) {
            window.CollectionServiceFavorites.getCollection(parseInt(me.pid, 10),parseInt(me.blid,10),parseInt($("#globalSubID").html(), 10),2,parseInt(me.id,10),
                function(result) {
                    me.index_sub = -1;
                    me.sublist = result;
                    me.loadSublist();
                    return true;
                },
                function(error) {
                    me.writeError(me.source + ".getSubList.WSCall", JSON.stringify(error));
                });
        }  else        {
           me.writeError(me.source + ".getSubList.checkVariables", "One or more of the variables is not integer");
        }
    } catch (ex) {
        me.writeError(me.source + ".getSubList", ex);
    }
};


CollectionFavorites.prototype.loadSublist = function () {
    ///<summary> 
    ///Sets the Sublist (the additional Playlist that is usually smaller) <br/>
    /// it creates the Divs for the Subcontent with some style additions <br/>
    /// or sets also an error Message if the Playlist is empty <br/>
    ///</summary>
    var me = this;
    var i;
    var s = "";
    var type;
    try {
        if ($(me.cs).css("display") !== "none") {
            if (parseInt($(me.cs).width(),10) > 500) {
                type = 2;
            } else {
                type = 1;
            }
            if (me.sublist === null || me.sublist.length < 1) {
                s += "<div id='content_sub_" + 0 + "' style='";
                s += "position:absolute;";
                s += "display:block;";
                s += "top:0px;";
                s += "left:0px;";
                s += "width:100%;";
                s += "height:" + parseInt($(me.cs).height() - 20, 10) + "px;'";
                s += "class='round subcontent'>";
                s += "<div class='info rem'><div class='error'>" + me.resources.errEmptyPlaylist + "</div></div>";
                s += "</div>";
            } else {
                for (i = 0; i < me.sublist.length; i++) {
                    //generate the divs
                    s += "<div id='content_sub_" + i + "' style='";
                    s += "position:absolute;";
                    s += "display:none;";
                    s += "top:0px;";
                    s += "left:0px;";
                    s += "width:" + parseInt($(me.cs).width(), 10) + "px;";
                    s += "height:" + parseInt($(me.cs).height() - 20, 10) + "px;'";
                    s += "class='round subcontent'>";
                    s += "</div>";
                    var width, height;
                    height = parseInt($(me.cs).height(), 10);
                    width = parseInt($(me.cs).width(), 10);
                    if (isNaN(width)) {
                        width = 0;
                    }
                    if (isNaN(height)) {
                        height = 0;
                    }
                    me.vcVisual.addVisualBaseByName(me.css, me.sublist[i].visualname, "_" + i.toString(), me.now, height, width, me.sublist[i].parameter, me.sublist[i].signalparameter, type);

                }
                window._VCMQ.produce(me.globalsDIV, 'COLLMQ', 'CHANGEENTRY_SUB');
                $(me.cs).append(s);

            }
        }
    
} catch (ex) {
        me.writeError(me.source + ".loadSublist", ex);
    }
};

/*
Returns a HTML-Element to indicate the length of the playlist.

@param {Boolean} the active element gets an other indicator
@param {String} the type of the indicator "circle" | "square" | "sqare-outline" | ...
@return {String} the HTML-Code for one single indicator */
CollectionFavorites.prototype.getIndicator = function(active, mode) {
    var me = this;
    var s = "";
    try {
        switch (mode.toLowerCase()) {
        case "circle":
            if (active) {
                s = "<i class='fas fa-circle'></i>";
            } else {
                s = "<i class='far fa-circle'></i>";
            }
            break;
        case "circle-outline":
            if (active) {
                s = "<i class='fas fa-dot-circle'></i>";
            } else {
                s = "<i class='far fa-dot-circle'></i>";
            }
            break;

        case "square":
            if (active) {
                s = "<i class='fas fa-square'></i>";
            } else {
                s = "<i class='far fa-square'></i>";
            }
            break;
        
        default:
            if (active) {
                s = "<i class='fas fa-square'></i>";
            } else {
                s = "<i class='far fa-square'></i>";
            }
            break;
        }
    } catch (ex) {
        me.writeError(me.source + "getIndicator", ex);
    }
    return s;
};



CollectionFavorites.prototype.runErrorProcedure = function (errorMsg) {
    ///<summary>
    /// Show the Error Message 
    ///</summary>
    var me = this;
    try {
    
        me.showInfo(me.resources.errGeneral, errorMsg, true);
        me.writeError("CollectionFavorites.runErrorProcedure", errorMsg);

    } catch (ex) {
        me.writeError("CollectionFavorites.runErrorProcedure", ex);
    }
};


CollectionFavorites.prototype.events = function (event) {
    ///<summary>
    /// Handles all Events in the Local JS-Message Queue
    ///</summary>
    var me = this;
    try {
        switch (event.msg) {
        case "PREV":
            me.addContentDiv();
           window._VCMQ.produce(me.globalsDIV, "COLLMQ", "HANDLER_SETPREV", me.handler.masterID);
            break;
        case "START":
            //Check if one id is missing or not set proprly...
            //Previously this was the Playlist ID
            me.collID = parseInt($("#globalCollID").html(), 10);
            me.subCollID = parseInt($("#globalSubID").html(), 10);
          
            if (isNaN(me.handler.themeID) || me.handler.themeID <= 0 ||
                isNaN(me.handler.masterID) || me.handler.masterID <= 0 ||
                isNaN(me.collID) || me.collID <= 0 ||
                isNaN(me.subCollID) ||
                isNaN(me.pid) || me.pid <= 0 ||
                isNaN(me.blid) || me.blid <= 0 ||
                isNaN(me.deviceID) || me.deviceID <= 0 ||
                isNaN(me.id) || me.id <= 0) {
                me.runErrorProcedure(me.visual.find('#divErrorMsg').html());
            } else {
                me.addContentDiv();
                //Show the loading div...
                window._VCMQ.produce(me.globalsDIV, 'COLLMQ', 'HANDLER_INIT', event.values);
                me.runCollection();
            }
            break;
        case "CHANGEENTRY":
            me.changeEntry();
            break;

        case "CHANGEENTRY_SUB":
            me.changeEntry_sub();
            break;

        case "PING":
            me.executePing();
            break;

        case "RELOAD":
            me.reloadURL();
            break;

        case "START_SUB":
            me.getSubList(event.values);
            break;

        case "SET_INDEX":
            me.index = event.values;
            break;
            case "CHANGE_PLAYLIST":
                me.changePlaylist(event.values);
                break;
            case "SET_VALUES":
                me.setValues(event.values);
                break;
        case "RUN_PLAYLIST":
            me.runPlaylist();
            break;
        case "RUN_COLLECTION":
            me.runCollection();
            break;
        case "LOAD_SINGLEWIDGET":
            me.setSingleWidget(event.values);
            break;
        case "SET_ENTRY":
            me.setEntry();
            break;
        default:
            break;
        }
    } catch (ex) {
        me.writeError(me.source + ".doEvent", ex);
    }
};

CollectionFavorites.prototype.changePlaylist = function (values) {
    ///<summary>
    /// Used to change the playlists <br />
    /// more or less on the fly in the Preview <br />
    ///</summary>
    var me = this;
    try {
       me.collID = values.mainid;
       me.subCollID = values.subid;
       me.getCollection();
        me.getSubList();
    } catch (ex) {
        me.writeError("CollectionFavorites.changePlaylist", ex);
    }

};

CollectionFavorites.prototype.setValues = function (values) {
    ///<summary>
    /// Used to set the Important IDs <br/>
    /// (Sub)CollectionID, MasterID and ThemeId
    ///</summary>
    ///<param name="values">Contains the Object with the values to set {"mainid"42, "subid":42, "masterID": 42, "themeID": 42}</param>
    var me = this;
    try {
        me.collID = values.mainid;
        me.subCollID = values.subid;
        me.masterID = values.masterID;
        me.themeID = values.themeID;
    } catch (ex) {
        me.writeError("CollectionFavorites.setValues", ex);
    }
};


CollectionFavorites.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This overrides the vcTemplate.specificInfoHandling and Hides all Divs except the Info Div <br/>
    /// additionally if calls the timerError and tries to reload the page
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find("*").not(".info, .info *").hide();
            me.visual.find('#divErrorNoCollection').show();
            me.visual.find("#info, #divCollectionContainer").show();
            $("#divCollectionContainer").show();
            clearTimeout(me.timer);
            clearTimeout(me.timerSub);
        }
        //reload after 5 minutes
        me.timerError = setTimeout(function () {
            window._VCMQ.produce(me.globalsDIV, 'COLLMQ', 'RELOAD');
        }, 5 * 60 * 1000);
    } catch (ex) {
        me.writeError(me.source + ".specificInfoHandling", ex);
    }
};
//#region 'Datastructures'
/*
Datastructure to load the weather widget. It holds all necessary variables.

@param {String} the first part of the div id
@param {String} the second part of the div id is used as VCGID
@param {JQuery} the div which should hold the widget
@param {String} the name of the widget
@param {String} the options needed by this widget */
        function Widget(container, widgetName, vcgid, div, widgetOptions, chartTheme, addBy) {
            this.container = container;
            this.widgetName = widgetName;
            this.vcgid = vcgid;
            this.div = div;
            this.widgetOptions = widgetOptions;
            this.chartTheme = chartTheme;
            if (typeof addBy === "undefined") {
                this.addBy = "byName";
            } else {
                this.addBy = addBy;
            }
        }
//#endregion